import { GlobalComposable } from "~/classes/composable/GlobalComposable"
import type { PropertyId } from "~/classes/entity"

class Authorization extends GlobalComposable {
  
    isAuthorizedToEditProperty = (file: StaticFile, propertyId?: PropertyId) => {
        const role = file.impliedSelfRole()
        return role.canEdit()
    }

    /** 
     * If we don't have permission to drop at all, let's not even show the drag/drop 
     * animations. Currently only applicable to anonymous users
     */
    isAuthorizedToDragFiles = () => {
        return useAuthentication().isAuthenticated()
    }

    isAuthorizedToMoveToFolder = (file: StaticFile, folder: StaticFile) => {
        const srcRole = file.impliedSelfRole()
        const destRole = folder.impliedSelfRole()
        return srcRole.canMove() && destRole.canUpload()
    }

    isAuthorizedToDownload = (file: StaticFile) => {
        const srcRole = file.impliedSelfRole()
        return srcRole.canDownload()
    }

    isAuthorizedToDownloadFile = (file: StaticFile) => {
        const srcRole = file.impliedSelfRole()
        return srcRole.canDownload()
    }
}

const authorization = new Authorization("authorization", theme.colors.pink.hex)
export default function () {
  return authorization.use()
}
